import type { OneTrust } from '@autobid/ui/composables/useOneTrust'

export const openOneTrustModal = () => {
  const oneTrust: OneTrust = 'OneTrust' in window ? window.OneTrust : {}

  typeof oneTrust.ToggleInfoDisplay === 'function' &&
    oneTrust.ToggleInfoDisplay()
}
